import cx from "classnames";
import React, { Fragment, useContext, useEffect, useState } from "react";
import { Link } from "react-router-dom";

// Utils

// Provider
import {
  AppContext,
  SET_ITEMSTATE,
  SET_NFTF_STATE,
  SET_PAGE_STATE,
} from "../../components/AppProvider";

// UI
import { Container, closeLayerFn, openLayerFn } from "../Layout";
import { MapView } from "../common/Modal/NaverMap";
import { CancelReceipt } from "./Reservation.Layers";

// imageImport
import _icon_video_file from "../../resources/images/icon/icon_hospital_location.png";

import { AlertTelLayer, ConfirmLayer } from "../../components/UI/Dialog";
import { PostApi1971, PostApi271 } from "../../modules/network/padoPost";
import { NativeAction } from "../../modules/utils/HandleWs";
import { reLogin } from "../common/AutoLogin/AutoLogin";
import ReceiptMod from "./ReceiptMod";
import ReserveCard from "./ReserveCard";
import useTitle from "../../modules/hooks/useTitle";

export const SUBS = [
  { url: "/surround", code: "SURND", label: "주변병원" },
  { url: "/resrvList", code: "RESRV", label: "예약현황" },
  { url: "/visit", code: "VISIT", label: "방문병원" },
];

export const SubMenu = props => {
  const { code } = props;

  return (
    <div className="top-roundtab-contain">
      <ul className="w3">
        {SUBS.map((m, i) => (
          <li key={i}>
            <Link to={m.url} className={cx({ on: code === m.code })}>
              {m.label}
            </Link>
          </li>
        ))}
      </ul>
    </div>
  );
};

export const Nothing = props => {
  const { contentHeight, text } = props;

  return (
    <div className="nothing-box">
      <div
        style={{
          position: "relative",
          height: contentHeight / 2,
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          padding: "0",
        }}>
        <div>
          <img src={_icon_video_file} alt="" />
          <p>{text ? text : "예약건이 없습니다."}</p>
        </div>
      </div>
    </div>
  );
};

// 예약목록
export const request271 = (
  userinfo,
  cfg,
  phonecfg,
  startDt,
  endDt,
  setResrvList
) => {
  PostApi271(userinfo, cfg, phonecfg, startDt, endDt)
    .then(res => {
      if (res.resultMsg === "SUCCESS") setResrvList(res.resultList);
    })
    .catch(err => {
      console.log(err);
    });
};

export const ResrvList = props => {
  const {
    resrvList,
    setHpKey,
    setHpNm,
    setAppIdx,
    setSelectHpNm,
    setHpLat,
    setHpLon,
    handleConfirm,
    setLocationInfo,
    contentHeight,
    handleDialog,
    setPharmInfo,
    setModifyMode,
    setConfirmActionType,
    nftfConnect,
    setNftfConnect,
    setResrvList,
  } = props;

  const { phonecfg } = useContext(AppContext);

  const resrvCancelLayer = (hpNm, hpKey, appIdx, bizType) => {
    setHpKey(hpKey);
    setHpNm(hpNm);
    setAppIdx(appIdx);
    setConfirmActionType(bizType);

    openLayerFn($(".reserv-cancle-layer"));
  };

  // useEffect(() => {
  // $(".btn-open-reserv-cancle").click(function () {
  //   alert(11111);
  //   openLayerFn($(".reserv-cancle-layer"));
  // });

  // $(".reserv-cancle-layer .gray").click(function () {
  //   alert(22222);
  //   closeLayerFn($(".reserv-cancle-layer"));
  // });

  // $(".location").click(function () {
  //   openLayerFn($(".map-view-layer"));
  // });

  // $(".map-view-layer .btn-closex").click(function () {
  //   closeLayerFn($(".map-view-layer"));
  // });

  // $(".map-view-layer .btn-backpage").click(function () {
  //   closeLayerFn($(".map-view-layer"));
  // });
  // }, []);

  const mapLayer = (hpNm, lat, lon, hospitalInfo) => {
    openLayerFn($(".map-view-layer"));

    NativeAction(phonecfg, "statusColor", "#FFFFFF");
    setSelectHpNm(hpNm);
    setHpLat(lat);
    setHpLon(lon);
    setLocationInfo(hospitalInfo);
  };

  return (
    <Fragment>
      {resrvList != null && resrvList.length > 0 ? (
        resrvList.map((m, i) => (
          <ReserveCard
            key={"rsrvCard" + i}
            data={m}
            mapLayer={mapLayer}
            handleConfirm={handleConfirm}
            resrvCancelLayer={resrvCancelLayer}
            handleDialog={handleDialog}
            setPharmInfo={setPharmInfo}
            setModifyMode={setModifyMode}
            nftfConnect={nftfConnect}
            setNftfConnect={setNftfConnect}
            setResrvList={setResrvList}
          />
        ))
      ) : (
        <Nothing list={resrvList} contentHeight={contentHeight} />
      )}
    </Fragment>
  );
};

export const RsrvListDtl = props => {
  const { list } = props;

  const copyToClipboard = val => {
    let sentence = val;
    let start = sentence.indexOf(":");
    let end = sentence.indexOf("(", start + 1);
    let accountInfo = sentence.substring(start + 2, end - 1);
    let t = document.createElement("textarea");

    document.body.appendChild(t);
    t.value = accountInfo;
    t.select();
    document.execCommand("copy");
    document.body.removeChild(t);

    // toastr.options = {
    //         closeButton: true,
    //         progressBar: true,
    //         positionClass: "toast-bottom-center",
    //         timeOut: 2000
    // };
    // toastr.success('', '계좌번호가 복사되었습니다.')
  };
  return (
    <div className="name">
      의사 <span>{list.appDR}</span> <br />
      {list.appCls == "1" &&
      list.appStatus != "1" &&
      list.amount != "0" &&
      list.payStatus == "1" ? (
        <Fragment>
          진료비 <span>{list.amount}원 [결제완료]</span> <br />
        </Fragment>
      ) : (
        list.amount != "0" && (
          <Fragment>
            진료비 <span>{list.amount}원</span> <br />
          </Fragment>
        )
      )}
    </div>
  );
};

export const getToday = type => {
  var date = new Date();
  var dd = date.getDate();
  var mm = date.getMonth() + 1;

  var yyyy = date.getFullYear();
  if (dd < 10) {
    dd = "0" + dd;
  }
  if (mm < 10) {
    mm = "0" + mm;
  }

  yyyy = yyyy.toString();
  mm = mm.toString();
  dd = dd.toString();

  var m = date.getHours();
  var s = date.getMinutes();

  if (m < 10) {
    m = "0" + m;
  }
  if (s < 10) {
    s = "0" + s;
  }
  m = m.toString();
  s = s.toString();

  var s1 = "";

  if (type == "DAY") {
    s1 = yyyy + mm + dd;
  } else if (type == "FULL") {
    s1 = yyyy + mm + dd + m + s;
  }

  return s1;
};

export default props => {
  useTitle("진료예약_예약현황");
  // 서브메뉴 활성화 값 (기본 0)
  const sub = SUBS[1];

  const {
    userinfo,
    cfg,
    phonecfg,
    auth,
    dispatch,
    itemState,
    pageState,
    nftfState,
  } = useContext(AppContext);

  const [modifyMode, setModifyMode] = useState(false);
  const [pharmInfo, setPharmInfo] = useState();

  // 예약 목록
  const [resrvList, setResrvList] = useState(null);
  const [hpKey, setHpKey] = useState(""); // 선택된 병원키
  const [hpNm, setHpNm] = useState(""); // 선택된 병원명
  const [appIdx, setAppIdx] = useState(null); // 선택된 예약ID
  const [selectHpNm, setSelectHpNm] = useState("");
  const [hpLat, setHpLat] = useState("");
  const [hpLon, setHpLon] = useState("");
  const [tell, setTell] = useState();

  const [locationInfo, setLocationInfo] = useState({});
  const [contentHeight, setContentHeight] = useState(0);
  const [confirmActionType, setConfirmActionType] = useState();

  // 비대면 연결 시도중 상태
  const [nftfConnect, setNftfConnect] = useState(false);

  const [dialog, setDialog] = useState({
    title: "",
    msg: "",
  });

  const request1971 = appStatus => {
    PostApi1971(userinfo, cfg, phonecfg, appIdx, appStatus)
      .then(res => {
        if (res.resultMsg === "SUCC") {
          // setResrvList(res.resultList);
          request271(
            userinfo,
            cfg,
            phonecfg,
            getToday("DAY"),
            getToday("DAY"),
            setResrvList
          );
        }
      })
      .catch(err => {
        console.log(err);
      });
  };

  const handleConfirm = (title, msg, appIdx) => {
    setDialog({
      title: title,
      msg: msg,
    });
    setAppIdx(appIdx);
    openLayerFn($(".confirm-layer"));
  };
  const handleConfirmConfirmCB = () => {
    request1971(4);
  };

  const handleConfirmCancelCB = () => {
    closeLayerFn($(".confirm-layer"));
  };

  const handleDialog = (title, msg, handleConfirmCB, tel) => {
    setDialog({
      title: title,
      msg: msg,
      handleConfirmCB: handleConfirmCB,
    });

    if (handleConfirmCB == "certi") {
      openLayerFn($(".confirm-layer"));
    } else {
      if (tel) {
        setTell(tel);
        openLayerFn($(".alert-tel-layer"));
      } else {
        openLayerFn($(".alert-layer"));
      }
    }
  };

  let userinfo2 = reLogin(auth, userinfo, dispatch);

  const getReserveList = () => {
    request271(
      userinfo,
      cfg,
      phonecfg,
      getToday("DAY"),
      getToday("DAY"),
      setResrvList
    );
  };

  useEffect(() => {
    getReserveList();
    setContentHeight(window.innerHeight);
    NativeAction(phonecfg, "statusColor", "#B2BEE6");
  }, []);

  useEffect(() => {
    // window.NativeInterface = {
    // itemState: value => {
    //   getReserveList();
    // },
    // webReload: value => {
    //   getReserveList();
    // },
    // openNftfRtn: value => {
    //   // value: 성공: 0, 실패: 1
    //   setNftfConnect(false);
    //   getReserveList();
    //   // if (JSON.parse(value).closeType.toString() === "1") {
    //   //   getReserveList();
    //   // } else {
    //   //   getReserveList();
    //   // }
    // },
    // };
  }, []);

  useEffect(() => {
    if (itemState.reload) {
      getReserveList();
      dispatch({
        type: SET_ITEMSTATE,
        data: { type: "COMPLETE" },
      });
    }
  }, [itemState.reload]);

  useEffect(() => {
    if (nftfState.reload) {
      setNftfConnect(false);
      getReserveList();
      dispatch({
        type: SET_NFTF_STATE,
        data: {
          type: "reload",
        },
      });
    }
  }, [nftfState.reload]);

  useEffect(() => {
    if (pageState.reload === 1) {
      getReserveList();
      dispatch({
        type: SET_PAGE_STATE,
        data: { type: "reload", state: 0 },
      });
    }
  }, [pageState.reload]);

  useEffect(() => {
    if (props.match.params.appID && resrvList) {
      window.scrollTo({
        left: 0,
        top: document
          .getElementById("1_" + props.match.params.appID)
          .getBoundingClientRect().top,
        behavior: "smooth",
      });
    }
  }, [props.match.params.appID, resrvList]);

  useEffect(() => {
    if (modifyMode === false) {
      NativeAction(phonecfg, "statusColor", "#B2BEE6");
    }
  }, [modifyMode]);

  return (
    <Fragment>
      {modifyMode ? (
        <ReceiptMod
          setModifyMode={setModifyMode}
          pharmInfo={pharmInfo}
          getReserveList={getReserveList}
        />
      ) : (
        <Fragment>
          <Container Title="예약현황" goToUrl="/" color="purple">
            <div className="contents sub grad" id="grad">
              {/* subTabMenu */}
              <SubMenu code={sub.code} />
              {/* /subTabMenu */}

              <div
                className="sub-contents"
                style={{ padding: "25px 20px 50px" }}>
                {/* 예약 리스트 */}
                {resrvList != null && (
                  <ResrvList
                    resrvList={resrvList}
                    setHpKey={setHpKey}
                    setHpNm={setHpNm}
                    setAppIdx={setAppIdx}
                    setSelectHpNm={setSelectHpNm}
                    setHpLat={setHpLat}
                    setHpLon={setHpLon}
                    handleConfirm={handleConfirm}
                    setLocationInfo={setLocationInfo}
                    contentHeight={contentHeight}
                    handleDialog={handleDialog}
                    setPharmInfo={setPharmInfo}
                    setModifyMode={setModifyMode}
                    setConfirmActionType={setConfirmActionType}
                    nftfConnect={nftfConnect}
                    setNftfConnect={setNftfConnect}
                    setResrvList={setResrvList}
                  />
                )}
                {/* / 예약 리스트 */}
              </div>
            </div>
          </Container>
          <CancelReceipt
            hpKey={hpKey}
            hpNm={hpNm}
            appIdx={appIdx}
            setResrvList={setResrvList}
            confirmActionType={confirmActionType}
          />
          {locationInfo && (
            <MapView
              // hpLat={hpLat}
              // hpLon={hpLon}
              // selectHpNm={selectHpNm}
              locationInfo={locationInfo}
            />
          )}
          <ConfirmLayer
            priv="priv"
            title={dialog.title}
            msg={dialog.msg}
            handleCancelCB={handleConfirmCancelCB}
            handleConfirmCB={handleConfirmConfirmCB}
          />
          <AlertTelLayer priv="priv" tel={tell} />
          {/* <ReceiptMod seqNo={seqNo} pharmNm={pharmNm} faxTelNo={faxTelNo} /> */}
        </Fragment>
      )}
    </Fragment>
  );
};
